import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TConfirmationRequestClientResponse } from 'shared/types/TDelivery';

type IState = {
  lastConfirmationResult: TConfirmationRequestClientResponse | null;
  isSmsSending: boolean;
  retryTimerSecondsLeft: number;
  isTimerRunning?: boolean;
};

const initialState: IState = {
  lastConfirmationResult: null,
  isSmsSending: false,
  retryTimerSecondsLeft: 0,
};

export const preApprovalsSlice = createSlice({
  name: 'preApprovals',
  initialState,
  reducers: {
    setSmsRetryTimerIsRunning: (state, action: PayloadAction<boolean>) => {
      state.isTimerRunning = action.payload;
    },
    updateRetryTimerSecondsLeft: (state, action: PayloadAction<number>) => {
      state.retryTimerSecondsLeft = action.payload;
    },
    setIsSmsSending: (state, action: PayloadAction<boolean>) => {
      state.isSmsSending = action.payload;
    },
    setLastConfirmationResult: (state, action: PayloadAction<TConfirmationRequestClientResponse | null>) => {
      state.lastConfirmationResult = action.payload;
    },
  },
});

export const { setSmsRetryTimerIsRunning, updateRetryTimerSecondsLeft, setIsSmsSending, setLastConfirmationResult } =
  preApprovalsSlice.actions;
